"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_CATALOG_PRODUCT_TREE = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_CATALOG_PRODUCT_TREE = (0, gql_1.gql)(`
  query catalogProductTree(
    $catalogId: ID!,
  ) {
    catalogs(ids: [$catalogId]) {
      edges {
        node {
          id
          productTrees(first: 1) {
            edges {
              node {
                id
                title
                myPermissions
                isLinkedToParent
                lastSyncedAt
                tags {
                  edges {
                    node {
                      id
                      key
                      value
                    }
                  }
                }
                root {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
`);
